import slideStyle from "./InfoPage.module.scss";
import ContactAppendix from "./ContactAppendix";
import Heading from "./Heading";
import { Message, getMessage, MessageContext } from "@messageformat/react";
import { useContext } from "react";

const KioskAI = () => {
  const messageContext = useContext(MessageContext);

  return (
    <>
      <Heading
        subtitle={<Message id="infoPages.devices.subtitle" />}
        title={<Message id="infoPages.devices.title" />}
        hints={[
          <Message id="infoPages.devices.hints.hint1" />,
          <Message id="infoPages.devices.hints.hint2" />,
          <Message id="infoPages.devices.hints.hint3" />,
        ]}
      />
      <div className={slideStyle.section}>
        <div>
          <h2>
            <Message id="infoPages.devices.title2" />
          </h2>
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(messageContext, "infoPages.devices.description")(),
            }}
          />
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-around",
              marginTop: "50px",
              fontWeight: "bold",
            }}
          >
            <div>
              <Message id="infoPages.devices.devices.hint1" />
            </div>
            <div>
              <Message id="infoPages.devices.devices.hint2" />
            </div>
            <div>
              <Message id="infoPages.devices.devices.hint3" />
            </div>
            <div>
              <Message id="infoPages.devices.devices.hint4" />
            </div>
          </div>
        </div>
      </div>

      <div className={slideStyle.posContainer}>
        <div className={slideStyle.biggerEmbeddedImg}>
          <img src={require("../assets/devices.png")} alt="POS" />
        </div>
      </div>

      <div className={slideStyle.section}>
        <div
          className={slideStyle.heading}
          style={{ marginTop: "20px", marginBottom: "20px" }}
        >
          <h1
            dangerouslySetInnerHTML={{
              __html: getMessage(messageContext, "infoPages.devices.summary")(),
            }}
          />
        </div>

        <ContactAppendix />
      </div>
    </>
  );
};

export default KioskAI;
